import React from "react";
import Logo from "./logo";
import LogoSmall from "./logo-small";
import LogoFooter from "./logo-footer";
import LogoFooter2 from "./logo-footer-2";
import ArrowRight from "./arrow-right";
import ChevronDown from "./chevron-down";
import Play from "./play";
import External from "./external";
import ArrowDown from "./arrow-down";
import ArrowDownSmall from "./arrow-down-small";
import Close from "./close";
import ArrowLeft from "./arrow-left";
import ChevronLeft from "./chevron-left";
import ChevronRight from "./chevron-right";
import Link from "./link";
import Twitter from "./twitter";
import LinkedIn from "./linkedin";
import Facebook from "./facebook";
import ArrowCarousal from "./arrow-carousal";
import CheckCircle from "./check-circle";
import ListTriangle from "./list-triangle";

function Icon(props) {
  switch (props.symbol) {
    case "logo":
      return <Logo />;
    case "logo-small":
      return <LogoSmall />;
    case "logo-footer":
      return <LogoFooter />;
    case "check-circle":
      return <CheckCircle />;
    case "list-triangle":
      return <ListTriangle />;
    case "logo-footer-2":
      return <LogoFooter2 />;
    case "arrow-right":
      return <ArrowRight />;
    case "chevron-down":
      return <ChevronDown />;
    case "play":
      return <Play />;
    case "external":
      return <External />;
    case "arrow-down":
      return <ArrowDown />;
    case "arrow-carousal":
      return <ArrowCarousal />;
    case "arrow-down-small":
      return <ArrowDownSmall />;
    case "close":
      return <Close />;
    case "arrow-left":
      return <ArrowLeft />;
    case "chevron-left":
      return <ChevronLeft />;
    case "chevron-right":
      return <ChevronRight />;
    case "link":
      return <Link />;
    case "twitter":
      return <Twitter />;
    case "linkedin":
      return <LinkedIn />;
    case "facebook":
      return <Facebook />;
    default:
      return <span>Unknown icon: {props.symbol}</span>;
  }
}

export default Icon;
